// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2dhLk","text":"SelectPayment_text__3FlEA","title":"SelectPayment_title__2V5Lv","btn":"SelectPayment_btn__2Oo2n"};